export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
}

export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export interface FaqItem {
  question: string;
  answer: string;
}

export const categories: Category[] = [
  { slug: 'dianying', name: '电影', description: '热门大片、经典佳作、院线新片，畅享影院级观影体验', icon: 'ri-movie-2-line' },
  { slug: 'dianshiju', name: '电视剧', description: '国产剧、韩剧、美剧、日剧，海量剧集持续更新', icon: 'ri-tv-2-line' },
  { slug: 'zongyi', name: '综艺', description: '热门综艺、真人秀、脱口秀，欢乐不停歇', icon: 'ri-emotion-laugh-line' },
  { slug: 'dongman', name: '动漫', description: '日漫、国漫、经典番剧，二次元世界任你遨游', icon: 'ri-rocket-line' },
  { slug: 'jilupian', name: '纪录片', description: '自然、历史、科技、人文，探索世界的每一个角落', icon: 'ri-earth-line' },
  { slug: 'yinyue', name: '音乐', description: 'MV、演唱会、音乐节目，让旋律触动你的心灵', icon: 'ri-music-2-line' },
  { slug: 'tiyu', name: '体育', description: '赛事直播、精彩集锦、体育资讯，热血澎湃', icon: 'ri-basketball-line' },
  { slug: 'youxi', name: '游戏', description: '游戏实况、电竞赛事、攻略解说，玩家聚集地', icon: 'ri-gamepad-line' },
];

export const articles: Article[] = [
  {
    slug: 'moguvideo-v3-update',
    title: '蘑菇视频 V3.0 全新升级：AI智能推荐引擎重磅上线',
    excerpt: '蘑菇视频正式发布V3.0版本，全新AI智能推荐引擎可根据您的观看习惯精准推送内容，同时还带来了全新界面设计和更流畅的播放体验。',
    content: `<p>蘑菇视频团队经过数月的研发与优化，正式推出V3.0全新版本。本次更新围绕"智能、流畅、美观"三大核心方向，为用户带来前所未有的视频观看体验。</p>
<h2>AI智能推荐引擎</h2>
<p>新版蘑菇视频搭载了自研的AI智能推荐引擎，能够深度分析用户的观看习惯、兴趣偏好和互动行为，实现千人千面的精准内容推荐。无论您是喜欢动作大片、治愈系动漫，还是深度纪录片，蘑菇视频都能为您找到最合适的内容。</p>
<p>推荐引擎采用深度学习模型，支持实时学习用户行为变化。当您的兴趣发生改变时，推荐内容也会随之调整，永远保持新鲜感。</p>
<h2>全新界面设计</h2>
<p>V3.0版本采用了全新的Material You设计语言，界面更加简洁美观，操作逻辑更加直观。首页布局经过重新设计，重要功能一目了然，让您能更快找到想看的内容。</p>
<p>深色模式也进行了全面优化，在暗光环境下观看更加舒适护眼。同时新增了多种主题配色方案，满足不同用户的个性化需求。</p>
<h2>播放体验全面升级</h2>
<p>播放器内核从底层进行了重构，支持H.265/HEVC编码格式，在同等画质下可节省30%的带宽消耗。新增智能缓冲技术，即使在网络不稳定的情况下也能流畅播放。</p>
<p>画质方面，新增了4K HDR支持和杜比全景声（Dolby Atmos），为高端设备用户带来影院级的视听享受。</p>
<h2>安全性能提升</h2>
<p>新版本进一步加强了安全防护机制，采用端到端加密传输技术，保障用户隐私安全。同时优化了应用启动速度，冷启动时间缩短了40%，让您更快进入观影状态。</p>
<p>还在等什么？立即下载蘑菇视频V3.0，开启全新的观影之旅吧！</p>`,
    category: 'dongman',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20modern%20tech%20office%20with%20a%20futuristic%20video%20interface%20on%20a%20large%20monitor%20displaying%20AI%20recommendations%20and%20streaming%20analytics%2C%20warm%20coral%20pink%20and%20white%20ambient%20lighting%2C%20clean%20minimalist%20workspace%2C%20soft%20shadows%2C%20professional%20cinematic%20photography%2C%208k%20resolution%20quality&width=1200&height=675&seq=moguvideo-article-v3&orientation=landscape',
    author: '蘑菇视频团队',
    publishDate: '2026-08-10',
    readTime: '5分钟',
    tags: ['版本更新', 'AI推荐', '新功能'],
  },
  {
    slug: 'summer-blockbusters-2026',
    title: '2026暑期档必看片单：十大热门电影推荐',
    excerpt: '暑期档火热来袭！我们为你精心挑选了2026年暑期档十大必看电影，涵盖动作、科幻、动画等多种类型，总有一部适合你。',
    content: `<p>炎炎夏日，还有什么比在空调房里看一部好电影更惬意的事呢？蘑菇视频为大家整理了2026年暑期档十大必看电影，快来看看有没有你期待的！</p>
<h2>动作大片</h2>
<p><strong>《极限追击3》</strong>——经典动作系列最新力作，场面更加宏大，动作戏更加惊险刺激。主演亲自完成90%的特技动作，让人肾上腺素飙升。</p>
<p><strong>《暗影特工》</strong>——谍战题材全新突破，剧情反转层出不穷，被誉为"今年最聪明的动作片"。</p>
<h2>科幻巨制</h2>
<p><strong>《星际迷航：新纪元》</strong>——经典科幻IP重启之作，视觉效果达到新高度，IMAX版本体验更佳。</p>
<p><strong>《AI纪元》</strong>——探讨人工智能与人类关系的深度科幻片，既有震撼的视觉场面，也有发人深省的哲学思考。</p>
<h2>动画精品</h2>
<p><strong>《猫狗大冒险》</strong>——适合全家观看的合家欢动画，萌宠题材加上暖心故事，绝对是暑期带娃神器。</p>
<p><strong>《山海经之九尾传说》</strong>——国产动画又一力作，以中国神话为背景，画面精美绝伦，展现了中国动画的顶尖水准。</p>
<h2>口碑佳作</h2>
<p><strong>《小城夏天》</strong>——文艺片惊喜之作，讲述了一个关于成长与离别的温暖故事，在某瓣评分高达8.7。</p>
<p><strong>《深夜的便利店》</strong>——日本治愈系电影，以一家深夜便利店为舞台，展现了都市夜归人的百态人生。</p>
<p>以上所有影片均可在蘑菇视频在线观看或下载，会员更享高清画质和免广告特权。快打开蘑菇视频，开启你的暑期观影之旅吧！</p>`,
    category: 'dianying',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20cinema%20theater%20interior%20with%20warm%20golden%20lighting%20and%20red%20velvet%20seats%2C%20a%20large%20movie%20screen%20showing%20a%20vibrant%20animated%20scene%2C%20cinematic%20atmosphere%2C%20professional%20photography%2C%20elegant%20composition%2C%20soft%20ambient%20glow&width=1200&height=675&seq=moguvideo-article-summer&orientation=landscape',
    author: '影评人小王',
    publishDate: '2026-08-08',
    readTime: '6分钟',
    tags: ['电影推荐', '暑期档', '片单'],
  },
  {
    slug: 'moguvideo-membership-guide',
    title: '蘑菇视频会员权益全解析：哪种套餐最适合你？',
    excerpt: '蘑菇视频提供多种会员套餐选择，本文将详细解析各档会员的权益差异，帮助你选择最适合自己需求的套餐方案。',
    content: `<p>随着蘑菇视频内容的不断丰富，越来越多的用户选择开通会员以获得更好的观影体验。但面对多种会员套餐，很多用户不知道该如何选择。本文将详细解析各档会员权益，帮您做出最佳选择。</p>
<h2>会员套餐概览</h2>
<p>蘑菇视频目前提供三种会员套餐：<strong>基础会员</strong>、<strong>高级会员</strong>和<strong>家庭会员</strong>。每种套餐针对不同用户群体设计，满足多样化的观影需求。</p>
<h2>基础会员（9.9元/月）</h2>
<p>适合轻度用户和偶尔观看的用户：</p>
<ul>
<li>全站1080P高清观看</li>
<li>每月3次离线下载</li>
<li>部分广告减免</li>
<li>1台设备同时在线</li>
</ul>
<h2>高级会员（19.9元/月）</h2>
<p>适合重度观影用户，也是目前最受欢迎的套餐：</p>
<ul>
<li>全站4K HDR超清观看</li>
<li>无限次离线下载</li>
<li>全站免广告</li>
<li>杜比全景声支持</li>
<li>2台设备同时在线</li>
<li>专属会员内容抢先看</li>
<li>每月赠送2张观影券</li>
</ul>
<h2>家庭会员（29.9元/月）</h2>
<p>适合家庭用户，一份会员全家共享：</p>
<ul>
<li>包含高级会员全部权益</li>
<li>5台设备同时在线</li>
<li>子账号管理功能</li>
<li>儿童模式专属内容</li>
<li>每月赠送5张观影券</li>
</ul>
<h2>如何选择？</h2>
<p>如果您只是偶尔看看视频，基础会员足够满足需求。如果是重度视频用户，推荐选择高级会员，性价比最高。如果全家人都使用蘑菇视频，家庭会员是最划算的选择——平均每人每月不到6元。</p>
<p>现在开通年费会员还可享受8折优惠，不要错过哦！</p>`,
    category: 'zongyi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20luxurious%20golden%20membership%20card%20on%20a%20warm%20elegant%20background%20with%20soft%20lighting%2C%20premium%20feel%2C%20lifestyle%20photography%2C%20coral%20and%20gold%20accents%2C%20clean%20minimalist%20composition&width=1200&height=675&seq=moguvideo-article-member&orientation=landscape',
    author: '蘑菇视频客服',
    publishDate: '2026-08-05',
    readTime: '4分钟',
    tags: ['会员', '套餐', '使用指南'],
  },
  {
    slug: 'dongman-spring-2026',
    title: '2026春季新番推荐：这些动漫不容错过',
    excerpt: '2026年春季新番已经陆续上线，我们为大家精选了本季最值得追的十部动漫作品，涵盖热血、恋爱、奇幻等多种类型。',
    content: `<p>2026年春季新番已经陆续开播，本季的动漫作品质量相当高，让人眼花缭乱。蘑菇视频动漫频道为大家精选了本季最值得追的十部作品。</p>
<h2>热血战斗类</h2>
<p><strong>《焰之继承者》</strong>——本季最受期待的热血番，制作公司是曾打造多部经典的顶级团队。战斗场面流畅华丽，剧情紧凑不拖沓，首播即获得9.2的高分。</p>
<h2>恋爱治愈类</h2>
<p><strong>《四月是你的谎言·续》</strong>——经典作品的续作，延续了前作的治愈风格，讲述全新的故事线。画面唯美，音乐动听，让人不由自主沉浸其中。</p>
<h2>奇幻冒险类</h2>
<p><strong>《异世界食堂2》</strong>——美食番的经典代表，第二季带来了更多异世界美食和温暖人心的故事。看完只想说：好饿！</p>
<p>更多精彩新番，尽在蘑菇视频动漫频道，每周同步更新，会员还可提前观看最新一集！</p>`,
    category: 'dongman',
    coverImage: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20illustration%20with%20colorful%20characters%20in%20a%20spring%20cherry%20blossom%20landscape%2C%20warm%20pink%20and%20golden%20tones%2C%20Japanese%20animation%20aesthetic%2C%20dreamy%20atmosphere%2C%20high%20quality%20art&width=1200&height=675&seq=moguvideo-article-anime&orientation=landscape',
    author: '动漫达人阿杰',
    publishDate: '2026-08-01',
    readTime: '5分钟',
    tags: ['动漫', '新番', '推荐'],
  },
  {
    slug: 'sports-live-guide',
    title: '蘑菇视频体育频道观赛指南：不错过每一场精彩赛事',
    excerpt: '蘑菇视频体育频道覆盖足球、篮球、网球等数十项运动赛事，本文将教您如何利用蘑菇视频的赛事日历和直播提醒功能。',
    content: `<p>对于体育迷来说，错过一场重要的比赛是最痛苦的事情。蘑菇视频体育频道提供了全方位的赛事观看解决方案，让您不错过每一场精彩对决。</p>
<h2>赛事日历功能</h2>
<p>蘑菇视频体育频道内置了智能赛事日历，覆盖足球（英超、西甲、中超等）、篮球（NBA、CBA等）、网球（四大满贯）、F1等数十项赛事。您可以按运动类型、联赛、球队进行筛选，一键查看赛程安排。</p>
<h2>直播提醒</h2>
<p>担心忘记比赛时间？只需在赛事页面点击"预约提醒"，蘑菇视频将在比赛开始前15分钟和5分钟分别推送通知，确保您准时收看。</p>
<h2>精彩回放</h2>
<p>错过了直播也没关系！蘑菇视频提供完整赛事回放和精华集锦，会员更可享受1080P高清回放画质。精彩进球、关键瞬间，一个都不错过。</p>
<p>立即打开蘑菇视频体育频道，开启您的观赛之旅！</p>`,
    category: 'tiyu',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20sports%20stadium%20filled%20with%20enthusiastic%20fans%20under%20bright%20stadium%20lights%2C%20warm%20golden%20and%20coral%20atmosphere%2C%20dramatic%20lighting%2C%20professional%20sports%20photography%2C%20wide%20angle%20view&width=1200&height=675&seq=moguvideo-article-sports&orientation=landscape',
    author: '体育编辑老张',
    publishDate: '2026-07-28',
    readTime: '3分钟',
    tags: ['体育', '赛事', '直播'],
  },
  {
    slug: 'kids-mode-guide',
    title: '蘑菇视频儿童模式上线：给孩子一个安全纯净的观影空间',
    excerpt: '蘑菇视频全新推出儿童模式，专为0-12岁儿童打造的安全观影环境。智能内容过滤、时长管理、护眼提醒，让家长更放心。',
    content: `<p>随着越来越多的小朋友使用蘑菇视频观看动画片和儿童节目，我们特别推出了"儿童模式"功能，为孩子们打造一个安全、健康、有趣的专属观影空间。</p>
<h2>智能内容过滤</h2>
<p>儿童模式采用AI智能过滤技术，确保所有展示内容都适合0-12岁儿童观看。内容库经过专业儿童教育顾问团队审核，涵盖动画、儿歌、科普、故事等多种类型。</p>
<h2>家长管控功能</h2>
<p>家长可以设置每日观看时长限制（30分钟/1小时/2小时），到达时间后自动锁屏。同时还支持内容白名单设置，家长可以手动选择允许孩子观看的节目列表。</p>
<h2>护眼模式</h2>
<p>内置护眼算法，每隔20分钟自动弹出休息提醒，引导孩子做眼保健操。屏幕色温自动调节，在暗光环境下自动降低蓝光输出。</p>
<h2>儿童专属界面</h2>
<p>儿童模式拥有独立的UI设计，大图标、明亮色彩、简单操作，小朋友可以轻松上手。退出儿童模式需要家长密码验证，确保孩子不能随意切换。</p>
<p>蘑菇视频儿童模式，让家长更放心，让孩子更开心！</p>`,
    category: 'dongman',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cozy%20kids%20room%20with%20a%20tablet%20showing%20colorful%20cartoon%20animation%2C%20soft%20pastel%20colors%2C%20warm%20natural%20light%20coming%20through%20window%2C%20happy%20atmosphere%2C%20professional%20photography%2C%20clean%20composition&width=1200&height=675&seq=moguvideo-article-kids&orientation=landscape',
    author: '蘑菇视频产品团队',
    publishDate: '2026-07-20',
    readTime: '4分钟',
    tags: ['儿童模式', '家长管控', '新功能'],
  },
];

export const faqItems: FaqItem[] = [
  {
    question: '蘑菇视频是免费的吗？',
    answer: '蘑菇视频提供免费和会员两种观看模式。免费用户可观看大部分内容（含广告），会员用户享受全站免广告、4K超清画质、杜比全景声、无限下载等专属权益。基础会员9.9元/月，高级会员19.9元/月，家庭会员29.9元/月。',
  },
  {
    question: '蘑菇视频支持哪些设备？',
    answer: '蘑菇视频支持安卓手机、安卓平板、安卓TV、iPhone、iPad、Apple TV等主流设备。同一账号可在多设备间无缝切换观看，高级会员支持2台设备同时在线，家庭会员支持5台设备同时在线。',
  },
  {
    question: '下载的视频可以离线观看吗？',
    answer: '当然可以！蘑菇视频支持离线下载功能，您可以在有Wi-Fi时将视频下载到本地，之后在没有网络的环境下也能观看。基础会员每月可下载3次，高级会员和家庭会员支持无限次下载。下载的视频在会员有效期内均可观看。',
  },
  {
    question: '蘑菇视频支持哪些画质？',
    answer: '蘑菇视频支持流畅（360P）、标清（480P）、高清（720P）、超清（1080P）和4K HDR等多种画质选项。系统会根据您的网络状况和设备性能自动选择最佳画质，您也可以在播放器中手动切换画质。高级及以上会员可畅享全站4K超清内容。',
  },
  {
    question: '如何取消蘑菇视频会员自动续费？',
    answer: '您可以在蘑菇视频App内进入"我的"→"会员中心"→"管理订阅"，关闭自动续费开关。如果您是通过应用商店订阅的，也可以在相应的应用商店（App Store或Google Play）订阅管理中取消。取消后当前会员周期仍可继续使用至到期日。',
  },
  {
    question: '蘑菇视频的内容有版权吗？',
    answer: '蘑菇视频始终坚持正版路线，所有内容均通过正规渠道获取版权授权。我们与国内外数百家内容制作方建立了长期合作关系，确保用户观看的每一部作品都是正版授权内容。选择蘑菇视频，就是选择尊重知识产权、支持创作者。',
  },
  {
    question: '为什么有些视频显示"您所在的地区暂不支持播放"？',
    answer: '由于版权协议的地域限制，部分内容的播放权限仅限特定地区。我们正在努力扩大版权覆盖范围，让更多地区的用户能够观看更多内容。如果您遇到此问题，可以尝试联系客服了解具体情况。',
  },
  {
    question: '蘑菇视频如何保障用户隐私安全？',
    answer: '蘑菇视频高度重视用户隐私保护，我们采用业界领先的端到端加密传输技术，所有用户数据均经过严格的脱敏处理和加密存储。我们承诺不会向任何第三方出售或泄露您的个人信息。具体隐私政策可在"设置"→"隐私政策"中查看。',
  },
];

export const features = [
  { icon: 'ri-smartphone-line', title: '多端同步', description: '手机、平板、电视无缝切换，随时随地畅享观影' },
  { icon: 'ri-download-2-line', title: '离线下载', description: '支持离线缓存，无网络也能畅快观看' },
  { icon: 'ri-4k-line', title: '4K超清', description: 'HDR画质加持，杜比全景声震撼体验' },
  { icon: 'ri-shield-check-line', title: '正版保障', description: '全站正版内容，安全可靠无病毒' },
  { icon: 'ri-speed-up-line', title: '极速播放', description: '智能缓冲技术，流畅不卡顿' },
  { icon: 'ri-parent-line', title: '儿童模式', description: '专属内容过滤，家长放心孩子开心' },
];

export const stats = [
  { value: '5000万+', label: '累计用户' },
  { value: '10万+', label: '视频内容' },
  { value: '99.9%', label: '播放成功率' },
  { value: '4.9', label: '用户评分' },
];

export const testimonials = [
  { name: '张先生', role: '高级会员 2年', content: '蘑菇视频的4K画质真的惊艳，搭配家庭影院看大片太爽了！资源也很全，想看的片子基本都有。', avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Chinese%20man%20in%20his%2030s%2C%20clean%20white%20background%2C%20friendly%20smile%2C%20professional%20portrait%20photography%2C%20soft%20lighting&width=80&height=80&seq=avatar-01&orientation=squarish' },
  { name: '李女士', role: '家庭会员 1年', content: '儿童模式简直是我们家的救星！给孩子设置了观看时长后，再也不用担心他沉迷看动画片了，内容也很健康。', avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20Chinese%20woman%20in%20her%2030s%2C%20clean%20white%20background%2C%20warm%20smile%2C%20professional%20portrait%20photography%2C%20soft%20lighting&width=80&height=80&seq=avatar-02&orientation=squarish' },
  { name: '王同学', role: '基础会员 6个月', content: '作为学生党，9.9元一个月的价格太友好了！视频更新速度很快，追剧追番都很方便，强烈推荐！', avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Chinese%20male%20student%2C%20clean%20white%20background%2C%20bright%20smile%2C%20professional%20portrait%20photography%2C%20soft%20lighting&width=80&height=80&seq=avatar-03&orientation=squarish' },
];